import axios from "axios";
import HttpClient from "../HttpClient";
import { CreateResult, GetListResult, GetOneResult, UpdateResult } from "react-admin";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import {
    CampaignPageResponse,
    CreateCampaignPage,
    UpdateCampaignPage,
} from "../interfaces/CampaignPage/CampaignPage";

export default class CampaignPageService {
    async fetchAllCampaignPages(
        limit: number,
        offset: number,
        filters: any,
        sort: {}
    ): Promise<GetListResult<CampaignPageResponse>> {
        filters = ConstructSequelizeFilters(
            filters,
            ["slug", "campaignName"],
            ["service", "isActive", "noindex"],
        );
        const data = await HttpClient.get("/centaurus/campaign-page", {
            params: {
                limit,
                offset,
                filters,
                sort,
            },
        });
        return {
            data: (!!data && !!data?.data) ? data?.data?.data : [],
            total: (!!data && !!data?.data) ? data?.data?.count : 0,
        };
    }

    async getOneCampaignPage(id: number): Promise<GetOneResult<CampaignPageResponse>> {
        const res = await HttpClient.get(`/centaurus/campaign-page/${id}`);
        return {
            data: res?.data,
        };
    }

    async createCampaignPage(payload: CreateCampaignPage): Promise<CreateResult<CampaignPageResponse>> {
        const res = await HttpClient.post(`/centaurus/campaign-page`, payload);
        return {
            data: res?.data,
        };
    }

    async updateCampaignPage(id: number, payload: UpdateCampaignPage): Promise<UpdateResult<CampaignPageResponse>> {
        const res = await HttpClient.patch(`/centaurus/campaign-page/${id}`, payload);
        return {
            data: res?.data,
        };
    }

    async getBannerUploadLinks(fileName: string): Promise<{ putUrl: string; getUrl: string }> {
        const data = await HttpClient.get("uploadImage/getSignedUrl", {
            params: {
                directory: "campaignBanners",
                fileName,
            },
        });
        return data?.data;
    }

    async uploadBanner(url: string, file: File | Blob) {
        return await axios.put(url, file);
    }
}
